import React, { useEffect, useState } from 'react';
import { useAuth } from '@common/auth/use-auth';
import { PageErrorMessage } from '@common/errors/page-error-message';
import { StaticPageTitle } from '@common/seo/static-page-title';
import { Trans } from '@ui/i18n/trans';
import { ShopHistory } from '@app/web-player/shop/shop-history'; // Componente que renderiza o histórico

interface Purchase {
  id: number;
  item_id: number;
  title: string;
  image_url: string;
  purchase_date: string;
  amount: number;
  status: string;
}

export function HistoricoCompras() {
  const { user } = useAuth(); // Obtém o usuário logado
  const [purchases, setPurchases] = useState<Purchase[]>([]);
  const [isError, setIsError] = useState(false);

  const fetchPurchaseHistory = async () => {
    if (!user) return;

    try {
      const response = await fetch(`/api/purchase_history.php?userId=${user.id}`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error('Erro ao carregar histórico de compras.');
      }

      setPurchases(data);
    } catch (error) {
      console.error(error);
      setIsError(true);
    }
  };

  useEffect(() => {
    fetchPurchaseHistory();
  }, [user]);

  if (isError) {
    return <PageErrorMessage />;
  }

  return (
    <div>
      <StaticPageTitle>
        <Trans message="Histórico de Compras" />
      </StaticPageTitle>
      <h1 className="text-2xl font-semibold mb-4">
        <Trans message="Suas Compras" />
      </h1>

      {purchases.length === 0 ? (
        <p><Trans message="Você ainda não fez compras." /></p>
      ) : (
        <ShopHistory purchases={purchases} />
      )}
    </div>
  );
}
